module.exports = __webpack_public_path__ + "media/images/webpage/hotels/model_cases/family_baby-942b03dd45166083196a26efbcebbdab.webp";